export default __webpack_public_path__ + "static/media/Tedi N.bafe7804.png";